import React, { useMemo } from 'react';
import { View, StyleSheet } from '@react-pdf/renderer';

import { Customer, GetTransactionsViaTransactionNoResponse, LooseLeafBusinessInfo } from 'src/types';
import { TextRegularWarranty } from './TextWarranty';
import { ViewWarrantyRow } from './ViewWarranty';
import { warrantyViewStyles } from '../styles';

interface Props {
  customerInfo?: Customer;
  dateSold?: string;
  paymentMode?: string;
  transaction_no?: string;
  overrideOnURL?: string;
  looseLeafBusinessInfo?: LooseLeafBusinessInfo;
  transactionStateData?: GetTransactionsViaTransactionNoResponse | null;
}

const styles = StyleSheet.create({
  root: {
    marginTop: 60
  },
  firstColumn: {
    ...warrantyViewStyles.flex2,
    alignItems: 'center'
  },
  firstColumnValue: {
    ...warrantyViewStyles.flex1
    // borderBottomWidth: 0.5
  },
  secondColumn: {
    ...warrantyViewStyles.flex1,
    marginLeft: 6
  },
  secondColumnValue: {
    ...warrantyViewStyles.flex1
    // borderBottomWidth: 0.5
  },
  secondRow: {
    marginTop: 4
  },
  oneliner: {
    height: 10,
    overflow: 'hidden',
  },
  twoliner: {
    height: 20,
    overflow: 'hidden',
  }
});

const businessAddressPaddingLeftString = "\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0"

export const RenderCustomerInfo = ({
  customerInfo,
  dateSold,
  looseLeafBusinessInfo
}: // paymentMode,
// overrideOnURL
Props) => {
  const customerName = useMemo(() => {
    const firstName = customerInfo?.first_name ?? '';
    const lastName = customerInfo?.last_name ?? '';
    return `${firstName} ${lastName}`;
  }, [customerInfo]);

  return (
    <View style={styles.root}>
      <ViewWarrantyRow>
        <ViewWarrantyRow style={styles.firstColumn}>
          <></>
        </ViewWarrantyRow>

        <ViewWarrantyRow style={[styles.secondColumn, {paddingLeft: 300}]}>
          <TextRegularWarranty style={styles.secondColumnValue}>
            {dateSold}
          </TextRegularWarranty>
        </ViewWarrantyRow>
      </ViewWarrantyRow>

      <ViewWarrantyRow style={styles.secondRow}>
        <ViewWarrantyRow style={[styles.firstColumn, styles.oneliner, {paddingLeft: 50}]}>
          <TextRegularWarranty style={styles.firstColumnValue}>
            {customerName}
          </TextRegularWarranty>
        </ViewWarrantyRow>

        {/* <ViewWarrantyRow style={styles.secondColumn}> <></>  </ViewWarrantyRow> */}
      </ViewWarrantyRow>

      {/* BUSINESS NAME */}
      <ViewWarrantyRow style={[styles.secondRow, {marginTop: 8}]}>
        <ViewWarrantyRow style={[styles.firstColumn, styles.oneliner, {paddingLeft: 70}]}>
          <TextRegularWarranty style={styles.firstColumnValue}>
            {looseLeafBusinessInfo?.business_name}
          </TextRegularWarranty>
        </ViewWarrantyRow>

        {/* <ViewWarrantyRow style={styles.secondColumn}> <></> </ViewWarrantyRow> */}
      </ViewWarrantyRow>

      {/* BUSINESS NAME */}
      <ViewWarrantyRow style={[styles.secondRow, {marginTop: 6}]}>
        <ViewWarrantyRow style={[styles.firstColumn, styles.oneliner, {paddingLeft: 30}]}>
          <TextRegularWarranty style={styles.firstColumnValue}>
            {looseLeafBusinessInfo?.tin}
          </TextRegularWarranty>
        </ViewWarrantyRow>

        <ViewWarrantyRow style={[styles.secondColumn, styles.oneliner, {paddingLeft: 200}]}>
          <TextRegularWarranty style={styles.secondColumnValue}>
            {looseLeafBusinessInfo?.terms}
          </TextRegularWarranty>
        </ViewWarrantyRow>
      </ViewWarrantyRow>

      {/* BUSINESS ADDRESS */}
      <ViewWarrantyRow style={[styles.secondRow, {marginTop: 6}]}>
        <ViewWarrantyRow style={[styles.firstColumn, styles.twoliner]}>
          <TextRegularWarranty style={[styles.firstColumnValue, {lineHeight: 1.22}]}>
            {`${businessAddressPaddingLeftString}${looseLeafBusinessInfo?.business_address || ''}`}
          </TextRegularWarranty>
        </ViewWarrantyRow>

        {/* <ViewWarrantyRow style={styles.secondColumn}>
          <TextRegularWarranty style={styles.secondColumnValue}>
            TERMS HERE TODO
          </TextRegularWarranty>
        </ViewWarrantyRow> */}
      </ViewWarrantyRow>
    </View>
  );
};
